import PageDescription from "./style";
import React from "react";

const MobilePageDescription = ({ children }) => (
  <PageDescription>{children}</PageDescription>
);

export default MobilePageDescription;
